// Google Analytics 4 integration with Consent Mode v2.
// Paste your GA4 Measurement ID below (looks like "G-XXXXXXXXXX").
// You can find it in GA4 → Admin → Data Streams → your web stream.
export const GA_MEASUREMENT_ID = "G-705JRQTL8G";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
    __gaLoaded?: boolean;
  }
}

const ensureGtag = () => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.gtag = function gtag(...args: any[]) {
      window.dataLayer!.push(args as unknown as Record<string, unknown>);
    };
  }
};

export const loadGa = () => {
  if (typeof window === "undefined") return;
  if (window.__gaLoaded) return;
  if (!GA_MEASUREMENT_ID) {
    // eslint-disable-next-line no-console
    console.warn("[GA4] Measurement ID not set in src/lib/ga.ts — skipping load.");
    return;
  }

  ensureGtag();

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag!("js", new Date());
  window.gtag!("config", GA_MEASUREMENT_ID, { send_page_view: false });
  window.__gaLoaded = true;
};

export const trackPageView = (path: string) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const grantConsent = () => {
  ensureGtag();
  window.gtag?.("consent", "update", {
    analytics_storage: "granted",
  });
};

export const denyConsent = () => {
  ensureGtag();
  window.gtag?.("consent", "update", {
    analytics_storage: "denied",
  });
};

export const CONSENT_KEY = "gs_consent";
export type ConsentValue = "granted" | "denied";

export const getStoredConsent = (): ConsentValue | null => {
  if (typeof window === "undefined") return null;
  const v = window.localStorage.getItem(CONSENT_KEY);
  return v === "granted" || v === "denied" ? v : null;
};

export const setStoredConsent = (v: ConsentValue) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CONSENT_KEY, v);
};
